import { Text, VFlow } from 'bold-ui'

export const AnexoArquivosInfoAccordion = () => {
  return (
    <VFlow vSpacing={0}>
      <Text color='primary'>
        <strong>1</strong> - Ao realizar um anexo, o PEC verifica o formato real do arquivo que está sendo anexado e
        permite somente arquivos com formato PDF, JPEG, JPG ou PNG.
      </Text>
      <Text color='primary'>
        <strong>2</strong> - É permitido selecionar somente um arquivo para realizar um anexo, e o profissional deve
        informar qual a categoria deste arquivo (Imagem de lesão; Exame de imagem; Exame de imagem odontológico; Exame
        laboratorial; Prontuário externo; Prescrição de medicamentos.).
      </Text>
      <Text color='primary'>
        <strong>3</strong> - Não é permitido anexar arquivos com tamanho maior que 5mb.
      </Text>
      <Text color='primary'>
        <strong>4</strong> - Como os arquivos anexados fazem parte do prontuário do cidadão, é recomendado que eles
        sejam guardados de acordo com a Lei nº 13.787/2018, que dispõe sobre a digitalização e a utilização de sistemas
        informatizados para a guarda, o armazenamento e o manuseio de prontuário de paciente.
      </Text>
      <Text color='primary'>
        <strong>5</strong> - Os arquivos anexados em um atendimento que não foram consolidados são deletados do
        diretório através de uma rotina de deleção. Para que eles sejam consolidados, o atendimento deve ser finalizado
        em até 7 dias e o registro de anexo não deve ter sido excluído.
      </Text>
    </VFlow>
  )
}
